module.exports = __webpack_public_path__ + "fonts/iconfont.06dabb92.woff";